import React from 'react';
import { Link } from 'react-scroll';
import './styles.scss';

interface ILink {
  title: string;
  to: string;
}

const CustomLink = ({ links }: { links: ILink[] }) => {
  const duration = 500;
  return (
    <ul styleName="wrapper">
      {links.map((item: ILink) => {
        return (
          <li key={item.title}>
            <Link
              to={item.to}
              spy
              smooth
              duration={duration}
              title={`Jump to: ${item.title}`}
            >
              {item.title}
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default CustomLink;
